export default __webpack_public_path__ + "static/logo-mono-white-3f6fd6244fb5a68a36ca9e440534c7d5.svg";